module.exports = __webpack_public_path__ + "static/media/20180529_174031.ce8955e7.jpg";